import { errorState } from '@sd/shared';
import { useRecoilValue } from 'recoil';

export const RaiseRecoilErrors = () => {
  const error = useRecoilValue(errorState);
  if (error) throw error;

  return null;
};
